import { IVibesAction, IVibesState, READ_COMMENT_ON_VIDEO } from '../types'

export const setReadCommentOnVideoId = (value: IVibesState): IVibesAction => ({
  type: READ_COMMENT_ON_VIDEO,
  value
})
